import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";

import MaterialIconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "../../../../theme/theme-provider";
import { Box, Row, Text, Img } from "../../../../comps";
import { faTrashAlt, faPlay } from "@fortawesome/free-solid-svg-icons";
import { playingGif } from "../../../../theme/uploaded";
import { songPaused as imgSongPaused } from "../../../../theme/image";

const GridItem = styled(Box)`
  height: 50px;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
  transition: opacity 0.3s;
  opacity: 1;
  overflow: hidden;
  border-radius: 4px;
`;

const SongWrapper = styled(Row)`
  width: 100%;
  height: 100%;
  align-items: center;
  background: ${({ focus, theme }) => focus && theme.color.BLACK_0};
`;

export default ({ song, isFocused, isPlaying, onRemove, onPlay }) => {
  const [hover, setHover] = useState(false);
  const { videoId, title, thumbnails } = song;

  return (
    <GridItem
      className={"item"}
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
    >
      <div class="item-content">
        <SongWrapper focus={isFocused}>
          <Img
            marginLeft="2%"
            width={16 * 4}
            height={9 * 4}
            src={
              (thumbnails &&
                (thumbnails.mediumUrl || thumbnails.standardUrl)) ||
              ""
            }
          />
          <Text
            marginLeft="5%"
            width={isPlaying || hover ? "55%" : "70%"}
            fontSize="16px"
            fontWeight="520"
            oneline={true}
            color={Theme.textColor.light}
          >
            {title}
          </Text>
          {!isFocused && hover && (
            <MaterialIconButton
              style={{ marginLeft: "auto" }}
              size="small"
              onClick={onPlay}
            >
              <FontAwesomeIcon style={{ color: "#f5f0f0e3" }} icon={faPlay} />
            </MaterialIconButton>
          )}
          {!isFocused && hover && (
            <MaterialIconButton
              style={{ marginLeft: "5%", marginRight: "5%" }}
              size="small"
              onClick={onRemove}
            >
              <FontAwesomeIcon
                style={{ color: "#f5f0f0e3" }}
                icon={faTrashAlt}
              />
            </MaterialIconButton>
          )}
          {isPlaying && (
            <Img
              marginLeft="auto"
              marginRight="5%"
              width={32}
              height={32}
              src={playingGif}
            />
          )}
          {isFocused && !isPlaying && (
            <Img
              marginLeft="auto"
              marginRight="5%"
              width={32}
              height={32}
              src={imgSongPaused}
            />
          )}
        </SongWrapper>
      </div>
    </GridItem>
  );
};
